import withUsers from '../../hoc/withUsers';
import TeamList from './TeamList';

export default withUsers(TeamList);
